// extracted by mini-css-extract-plugin
module.exports = {"feeSummary":"consultation-selection-v2_feeSummary__38toU","actions":"consultation-selection-v2_actions__2gs0N"};